import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

export const listAnimation = trigger('listAnimation', [
    transition('* <=> *', [
        query(':enter', [style({ opacity: 0 }), stagger('200ms', animate('600ms ease-out', style({ opacity: 1 })))], { optional: true }),
        query(':leave', animate('200ms', style({ opacity: 0 })), { optional: true }),
    ]),
]);

export const shiftAnimation = trigger('shiftAnimation', [
    transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.5) translateX(50px)', backgroundColor: '#6A52FD66' }),
        animate(
            '1500ms 1000ms ease-out',
            keyframes([
                style({ transform: 'scale(1.2)', offset: 0.3, boxShadow: '0 0px 40px #6A52FD66', border: '0px solid #ffffff' }),
                style({ transform: 'scale(1) translateX(0)', opacity: 1, offset: 1 }),
            ])
        ),
        animate('2000ms ease-out', style({ backgroundColor: '#ffffff' })),
    ]),
]);
